import React, { createContext, useContext } from 'react'
import { useSearchParams } from 'react-router-dom'
import { resolveDeviceOrigin, ResolvedDeviceOrigin } from '../utils/deviceOrigin'

/**
 * The query string that device links rendered inside a view append, so the opened
 * page knows where to lead Back. Empty outside any provider (e.g. monitoring).
 */
const DeviceOriginContext = createContext<string>('')

export function DeviceOriginProvider({
  search,
  children
}: {
  search: string
  children: React.ReactNode
}) {
  return <DeviceOriginContext.Provider value={search}>{children}</DeviceOriginContext.Provider>
}

export function useDeviceOriginSearch(): string {
  return useContext(DeviceOriginContext)
}

/**
 * The originating view of the current device-like page, or null for the default.
 */
export function useDeviceOrigin(projectId: number | null | undefined): ResolvedDeviceOrigin | null {
  const [searchParams] = useSearchParams()
  return resolveDeviceOrigin(searchParams, projectId)
}
